import { Spinner } from 'flowbite-react';
import { DimmedBackground } from '../../../components/common/dimmed/DimmedBackground';

export const LoadingPage = () => {
  return (
    <DimmedBackground
      isShow
      style={{
        background: '#0000003a',
        backdropFilter: 'none',
      }}
    >
      <div className={'w-full h-full flex justify-center items-center'}>
        <Spinner color={'info'} size={'xl'} />
      </div>
    </DimmedBackground>
  );
};
